import { FadeIn } from "./Reveal";

const IMG_BLUEPRINT = "/about-2.jpg";
const IMG_HANDS = "/about-1.jpg";

const Divider = () => (
  <div data-testid="about-divider" className="flex items-center max-w-2xl mx-auto py-6 lg:py-10" aria-hidden="true">
    <span className="flex-1 h-px bg-[#1C1B1A]/25" />
  </div>
);

export default function About() {
  return (
    <section id="chi-siamo" data-testid="about-section" className="relative bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          <FadeIn className="md:col-span-7">
            <div data-testid="about-intro" className="text-base sm:text-lg leading-loose text-[#1C1B1A]/80">
              <p>
                <span className="font-display text-2xl sm:text-3xl font-normal text-[#E30613]">FKL</span>
                {" "}è un'azienda edile specializzata in ristrutturazioni per privati e aziende.
                Offriamo soluzioni su misura per abitazioni, uffici e spazi commerciali, gestendo ogni intervento con un servizio completo e chiavi in mano.
              </p>
              <p className="mt-6">
                Affidabilità, competenza e attenzione ai dettagli ci permettono di trasformare ogni spazio in un ambiente funzionale, moderno e duraturo.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.15} className="md:col-span-5 flex justify-center">
            <div className="flex items-stretch gap-6">
              <span className="w-px bg-[#1C1B1A]/25" aria-hidden="true" />
              <img src={IMG_BLUEPRINT} alt="Progetto architettonico" className="w-56 h-56 sm:w-72 sm:h-72 object-cover" />
            </div>
          </FadeIn>
        </div>

        <FadeIn>
          <Divider />
        </FadeIn>

        <div className="grid md:grid-cols-12 gap-10 items-center">
          <FadeIn className="md:col-span-5 flex justify-center order-2 md:order-1">
            <div className="flex items-stretch gap-6">
              <img src={IMG_HANDS} alt="Ufficio tecnico al lavoro" className="w-56 h-56 sm:w-72 sm:h-72 object-cover" />
              <span className="w-px bg-[#1C1B1A]/25" aria-hidden="true" />
            </div>
          </FadeIn>
          <FadeIn delay={0.15} className="md:col-span-7 order-1 md:order-2">
            <p data-testid="about-ufficio-tecnico" className="text-base sm:text-lg leading-loose text-[#1C1B1A]/80">
              Esecuzione di interventi edilizi comprendenti opere strutturali, architettoniche e impiantistiche.
              Attività di pianificazione, direzione lavori e supervisione delle fasi di cantiere, con verifica della
              conformità ai progetti approvati, alle normative tecniche e ai capitolati.
            </p>
          </FadeIn>
        </div>
      </div>
      <img src="/fkl-logo.png" alt="" aria-hidden="true" className="absolute bottom-5 right-6 w-16 sm:w-20 pointer-events-none" />
    </section>
  );
}
